import type { RefObject, ReactNode } from 'react';

interface HiddenReportExportHostProps {
    exportRef: RefObject<HTMLDivElement | null>;
    children: ReactNode;
}

const HiddenReportExportHost = ({ exportRef, children }: HiddenReportExportHostProps) => (
    <div aria-hidden="true" className="pointer-events-none fixed -top-[200vh] -left-[200vw] opacity-0">
        <div className="w-[1280px]" ref={exportRef}>
            {children}
        </div>
    </div>
);

export default HiddenReportExportHost;
